// Unicode White_Space는 서버의 strings.TrimSpace와 같은 공백 집합을 사용합니다.
const surroundingWhitespace = /^\p{White_Space}+|\p{White_Space}+$/gu;

/** 원본 이름을 표시용으로 조합합니다. 이미 조합된 descriptor는 fallback으로만 전달합니다. */
export function formatPersonDisplayName(
  preferredName?: string | null,
  legalName?: string | null,
  fallback = '',
): string {
  const preferred = preferredName?.replace(surroundingWhitespace, '') ?? '';
  const legal = legalName?.replace(surroundingWhitespace, '') ?? '';
  if (!preferred) return legal || fallback;
  if (!legal || preferred === legal) return preferred;
  return `${preferred}(${legal})`;
}
